import cashierExpenses from '@/api/comptabilite/_depenses-caisse'
import { parseBackendTimestamp } from '@/utils/backend-timestamp'

// Dépenses par la caisse, validées après coup comme les remises : l'autorisant désigné (ou un
// administrateur) relit la dépense faite en son nom et la valide. Les droits viennent du serveur.
export default {
    name: 'DepensesCaisse',
    data() {
        return {
            statut: 'a_valider', from: '', to: '',
            items: [], total: 0, droits: {}, aValider: 0,
            loading: false, error: '', message: '',
            enValidation: null, commentaire: '', actionId: null, sequence: 0
        }
    },
    created() { this.refresh() },
    methods: {
        async refresh() {
            const sequence = ++this.sequence
            this.loading = true
            this.error = ''
            const params = { statut: this.statut }
            if (this.from) params.from = this.from
            if (this.to) params.to = this.to
            try {
                const [liste, nombre] = await Promise.all([cashierExpenses.list(params), cashierExpenses.countToValidate()])
                if (sequence !== this.sequence) return
                this.items = Array.isArray(liste.data) ? liste.data : []
                this.total = Number(liste.total) || 0
                this.droits = liste.droits || {}
                this.aValider = Number(nombre.data && nombre.data.a_valider) || 0
            } catch (error) {
                if (sequence === this.sequence) this.error = this.messageErreur(error, 'Impossible de charger les dépenses de caisse. Réessayez.')
            } finally {
                if (sequence === this.sequence) this.loading = false
            }
        },
        ouvrirValidation(item) {
            if (!item.peut_valider || this.actionId) return
            this.enValidation = item.id
            this.commentaire = ''
            this.message = ''
        },
        annulerValidation() { if (!this.actionId) this.enValidation = null },
        async valider(item) {
            if (!item.peut_valider || this.actionId) return
            this.actionId = item.id
            this.error = ''
            try {
                await cashierExpenses.validate(item.id, this.commentaire.trim())
                this.message = 'Dépense validée : ' + item.libelle + ' (' + this.montant(item.montant) + ').'
                this.enValidation = null
                await this.refresh()
            } catch (error) {
                this.error = this.messageErreur(error, 'La validation n’a pas été enregistrée. Réessayez.')
            } finally { this.actionId = null }
        },
        messageErreur(error, defaut) {
            return (error && error.response && error.response.data && typeof error.response.data.message === 'string')
                ? error.response.data.message : defaut
        },
        montant(valeur) { return Number(valeur || 0).toLocaleString('fr-FR') },
        dateHeure(valeur) {
            if (!valeur) return '—'
            const date = parseBackendTimestamp(valeur)
            return isNaN(date.getTime()) ? String(valeur) : date.toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: this.getClinicTimezone() })
        }
    }
}
